






import Vue from 'vue';
import { defineComponent, provide, inject, toRefs, computed } from '@vue/composition-api';
import { explodeRowProps } from './helpers';

export default defineComponent({
    name: 'WokDataGridRow',

    props: {
        highlight: {
            type: Boolean,
            default: false
        }
    },

    setup(props, context) {
        const rowProps = inject('wokDataGridRowProps') as { item: any };
        const { item, row, index } = explodeRowProps(inject('wokDataGridRowProps'));

        const rowClasses = computed(() => {
            return {
                'wok--data-grid__table-row': true,
                'wok--data-grid__table-row--highlight': props.highlight
            };
        });

        return {
            item,
            index,
            row,
            rowClasses
        }
    }
})
